export enum TextTrimViewEvent {
  expand = 'expand',
  collapse = 'collapse',
}
